module.exports = __webpack_public_path__ + "static/blog-img1-c7b81ff8886180a7a48b2871cf24ea8b.png";